<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <p v-if="!showSuccessAlert">{{ $t('kkm.closeCcmConfirmText', [formData.sfdNumber]) }}</p>
        <b-form-row class="justify-content-end mx-0" v-if="!showSuccessAlert">
            <b-button type="button" variant="danger" @click="closeModal" :disabled="isDisabled" class="mr-2">
                <close-icon title="" />&nbsp;{{ $t('kkm.no') }}
            </b-button>
            <b-button type="submit" variant="success" :disabled="isDisabled" @click="closeKkm">
                <save-icon title="" />&nbsp;{{ $t('kkm.yes') }}
            </b-button>
        </b-form-row>
    </b-card>
</template>

<script>
import AppData from '@/utils/appdata'

export default {
    name: 'KkmClose',
    mixins: [ AppData ],
    props: {
        ccmSfdNumber: String,
        closeModal: Function
    },
    data () {
        return {
            formData: {
                sfdNumber: this.ccmSfdNumber
            }
        }
    },
    methods: {
        closeKkm() {
            this.hideAlert()
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.close,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('kkm.ccmCloseSuccess', [this.formData.sfdNumber])
                }, this.displayAlert)
        }
    }
}
</script>
